module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table4E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("场所情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.placeSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "placeSituation", $$v)
      },
      expression: "params.placeSituation"
    }
  }, _vm._l((_vm.dicDats['C002']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.dicMap['C002'][_vm.params.placeSituation] == '其他') ? _c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherSituation", $$v)
      },
      expression: "params.otherSituation"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("场所所有权：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.placePower),
      callback: function($$v) {
        _vm.$set(_vm.params, "placePower", $$v)
      },
      expression: "params.placePower"
    }
  }, _vm._l((_vm.dicDats['C020']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.dicMap['C020'][_vm.params.placePower] == '其他') ? _c('el-input', {
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.params.otherPower),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherPower", $$v)
      },
      expression: "params.otherPower"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("面积（平米）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "placeArea",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "controls": false,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.placeArea),
      callback: function($$v) {
        _vm.$set(_vm.params, "placeArea", $$v)
      },
      expression: "params.placeArea"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.remark),
      callback: function($$v) {
        _vm.$set(_vm.params, "remark", $$v)
      },
      expression: "params.remark"
    }
  })], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-4：经营场所情况表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66bbdde8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/glanceDcp/table4.vue
// module id = 1760
// module chunks = 1